import React from 'react';

export const BryCard = ({
  children,
  title,
  subtitle,
  action,
  footer,
  hoverable = false,
  className = '',
  style = {},
  ...props
}) => {
  const hoverClass = hoverable ? 'bry-card-hover' : '';

  return (
    <div className={`bry-card ${hoverClass} ${className}`.trim()} style={style} {...props}>
      {(title || subtitle || action) && (
        <div className="bry-card-header">
          <div>
            {title && <h3 className="bry-card-title">{title}</h3>}
            {subtitle && <p className="text-secondary small mb-0 mt-1">{subtitle}</p>}
          </div>
          {action && <div className="bry-card-action">{action}</div>}
        </div>
      )}
      <div className="bry-card-body">{children}</div>
      {footer && <div className="bry-card-footer">{footer}</div>}
    </div>
  );
};
